import { gql } from "@apollo/client";

export default gql`
  mutation createOrUpdateTeamsNotificationForChannelMutation(
    $channelId: String
    $teamId: String
    $organizationId: Int
    $notificationId: Int
    $recognitions: Boolean
    $goalCheckins: Boolean
  ) {
    createOrUpdateTeamsNotificationForChannel(
      channelId: $channelId
      teamId: $teamId
      organizationId: $organizationId
      notificationId: $notificationId
      recognitions: $recognitions
      goalCheckins: $goalCheckins
    ) {
      organization {
        id
        teamsNotifications {
          edges {
            node {
              id
              teamId
              teamName
              channelId
              channelName
              recognitions
              goalCheckins
            }
          }
        }
      }
    }
  }
`;
